import React, { useState } from "react"
import styled from "@emotion/styled"
import { rgba } from "polished"
import Section from "src/components/Section"
import GreenhouseEmbed from "src/components/GreenhouseEmbed"
import Grid, { Container } from "src/components/Grid"
import TextLockup from "src/components/TextLockup"
import Button from "src/components/Button"
import AnimateHeight from "react-animate-height"
import { mq, globals, colors } from "src/styles"

const Wrapper = styled(Section)`
  text-align: ${({ alignment }) => alignment};
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const IntroTextWrapper = styled(Grid)`
  ${globals.verticalSpacing("padding-bottom", 0.5)}
  h1, h2 {
    max-width: 12em;
  }
  h3 {
    max-width: 18em;
  }
  h4,
  h5 {
    max-width: 24em;
  }
  h6 {
    max-width: 16em;
  }
  p {
    max-width: 36em;
  }
`

const GradientOverlay = styled.div`
  position: absolute;
  background: linear-gradient(
    0deg,
    ${rgba(colors.bgColor, 1)} 0%,
    ${rgba(colors.bgColor, 0)} 100%
  );
  bottom: 0;
  left: 0;
  width: 100%;
  height: 150px;
  ${({ visible }) =>
    visible
      ? `
    opacity: 1;
    visibility: visible;
  `
      : `
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  `}
`

const JobsListing = ({
  className,
  theme,
  spacing,
  prevTheme,
  nextTheme,
  id,
  introText,
  actions,
  hideMobile,
  hideDesktop,
}) => {
  const [sectionExpanded, setSectionExpanded] = useState(false)

  return (
    <Wrapper
      className={className}
      setTheme={theme}
      prevTheme={prevTheme}
      nextTheme={nextTheme}
      alignment="left"
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      {(introText?.eyebrow || introText?._rawText) && (
        <IntroTextWrapper small="container" medium="1 [12] 1">
          <TextLockup
            newStyle={introText?.newStyle}
            eyebrow={introText.eyebrow}
            text={introText._rawText}
            alignment="left"
            theme={theme}
            transitionIn={false}
          />
        </IntroTextWrapper>
      )}
      <Container medium="1 [12] 1">
        <div style={{ position: "relative" }}>
          <AnimateHeight
            duration={500}
            delay={0}
            animateOpacity={false}
            height={sectionExpanded ? "auto" : 800}
          >
            <div style={{ padding: "1px 0" }}>
              <GreenhouseEmbed />
            </div>
          </AnimateHeight>
          <GradientOverlay visible={!sectionExpanded} />
        </div>
        <div>
          <Button
            icon={sectionExpanded ? "close" : "add"}
            setTheme="lightGrey"
            onClick={() => setSectionExpanded(!sectionExpanded)}
          >
            {!sectionExpanded ? "View All" : "Hide"} Openings
          </Button>
        </div>
      </Container>
    </Wrapper>
  )
}

export default JobsListing
